import firebase from "./firebase.config";
import "firebase/auth";
const firebaseui = require('firebaseui');

export const auth = firebase.auth();

// Uncomment next line to use restricted access and add authorized users in .env
// export const validUsers = process.env.REACT_APP_USERS.split(',');

// Configure FirebaseUI.
export const uiConfig = {
  credentialHelper: firebaseui.auth.CredentialHelper.NONE,
  signInFlow: "popup",
  signInSuccessUrl: '/',
  signInOptions: [
    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  ]
};
